import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../utility/NavigationHelper";
import { toast } from "react-toastify";
import { AppScreens } from "../screens/Utility/AppScreens";

export const handleApiError = (
  statusCode: number,
  errorMessage: string = ""
) => {
  const navigation = useNavigation();
  const errorMessages = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    500: "Internal Server Error",
  };

  const defaultErrorMessage = "An unexpected error occurred";
  const toastMessage =
    errorMessages[statusCode] || errorMessage || defaultErrorMessage;

  toast.error(toastMessage);

  if (statusCode === 401 || statusCode === 403 || statusCode >= 500) {
    navigateToScreen(navigation, AppScreens.Home);
  }

  throw new Error(toastMessage);
};
